import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Renderads from './advertisement';
import SupportCard from './SupportCard';
import FlightLoadingScreen from './FlightLoadingScreen';
import { FaPhoneAlt, FaShip, FaClock, FaHeadset, FaTag } from 'react-icons/fa';

const CruiseContactCard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 800);
  }, []);

  if (loading) {
    return <FlightLoadingScreen />;
  }

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-blue-50 via-[#F5FFFA] to-blue-100">
      
      {/* Top Banner Ads */}
      <div className="w-full">
        <Renderads imgNumber={1} />
      </div>

      {/* Desktop Support Card */}
      <div className="hidden md:block mt-4 mb-10 px-4">
        <SupportCard />
      </div>

      {/* MAIN CRUISE CONTACT CARD */}

      <div className="max-w-4xl mx-auto px-4 pb-20">
        <div className="
          bg-white/70 backdrop-blur-xl border border-gray-200/60 
          shadow-2xl rounded-3xl px-6 sm:px-12 py-10 mt-10 relative overflow-hidden
        ">
          
          {/* Background gradient accent */}
          <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-to-br from-blue-300/40 to-blue-100/10 rounded-full blur-2xl opacity-40"></div>

          {/* Heading */}
          <div className="text-center mb-8">
            <FaShip className="mx-auto text-5xl text-blue-600 mb-3" />
            <h1 className="text-3xl font-extrabold text-gray-800 drop-shadow-sm">
              Cruise Deals & Reservations
            </h1>
            <p className="text-gray-600 mt-2 text-sm sm:text-base">
              Call our travel experts for **exclusive cruise offers, discounts, and upgrades**
            </p>
          </div>

          {/* CALL NOW BOX */}
          <div className="flex flex-col items-center text-center bg-gradient-to-r 
              from-blue-600 to-blue-500 text-white rounded-2xl p-6 shadow-lg">
            
            <p className="text-lg font-semibold mb-2">Speak with a Cruise Specialist</p>

            <a
              href="tel:+18887112909"
              className="flex items-center gap-3 bg-white text-blue-700 font-bold px-6 py-3 rounded-xl shadow-md hover:shadow-xl hover:scale-105 transition-all"
            >
              <FaPhoneAlt className="text-xl" />
              +1 888-711-2909
            </a>

            <p className="text-sm opacity-90 mt-2">Available 24/7 • Fast Booking • Best Price Guarantee</p>
          </div>

          {/* BENEFITS SECTION */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-10 text-center">
            <div className="bg-white shadow-md p-4 rounded-xl hover:shadow-xl transition">
              <FaHeadset className="text-2xl text-blue-600 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Live Assistance</p>
            </div>

            <div className="bg-white shadow-md p-4 rounded-xl hover:shadow-xl transition">
              <FaClock className="text-2xl text-blue-600 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Instant Help</p>
            </div>

            <div className="bg-white shadow-md p-4 rounded-xl hover:shadow-xl transition">
              <FaTag className="text-2xl text-blue-600 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Exclusive Prices</p>
            </div>

            <div className="bg-white shadow-md p-4 rounded-xl hover:shadow-xl transition">
              <FaShip className="text-2xl text-blue-600 mx-auto mb-2" />
              <p className="text-sm font-semibold text-gray-700">Top Cruise Lines</p>
            </div>
          </div>

          {/* CTA TO CRUISE PAGES */}
          <div className="mt-10 text-center">
            <Link
              to="/cruises"
              className="inline-block bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold px-8 py-3 rounded-xl shadow-lg hover:shadow-xl transition"
            >
              Explore Cruise Packages
            </Link>
          </div>

        </div>
      </div>

    </div>
  );
};

export default CruiseContactCard;
